export const WMS = "WMS";
export const TMS = "TMS";
export const Tileset = "Tileset";
export const GeoJSON = "GeoJSON";
export const ArcgisMapserver = "ArcgisMapserver";
export const Terrain = "Terrain";
export const PointCloud = "PointCloud";